/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { useState, useEffect } from "react";

const calculateMaxPages = (data, rowsPerPage) => {
	return data.length === 0 ? 0 : Math.ceil(data.length / rowsPerPage) - 1;
};

const sliceData = (data, page, rowsPerPage) => {
	return data.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
};

/**
 * Maintains pagination for the table and slices the rows data as per page no, rows per page count.
 * @param {Array} data Array of row objects
 * @returns table sliced rows, page no, rows per page.
 */
const usePagination = (data, defaultRowsPerPage = 10) => {
	const [pageNo, setPageNo] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
	const [dataSlice, setDataSlice] = useState([]);

	useEffect(() => {
		const maxPageNo = calculateMaxPages(data, rowsPerPage);
		if (pageNo > maxPageNo) setPageNo(maxPageNo);
		const slice = sliceData(data, pageNo, rowsPerPage);
		setDataSlice([...slice]);
	}, [data, pageNo, setDataSlice, rowsPerPage, setPageNo]);

	return { setPageNo, setRowsPerPage, pageNo, rowsPerPage, dataSlice };
};

export default usePagination;
